import { API_BASE } from '../utils/config';
import { Product } from '../types';

export interface HomeBanner {
  id: string;
  title: string | null;
  subtitle: string | null;
  description: string | null;
  button_text: string | null;
  button_link: string | null;
  image_url: string;
  display_order: number;
  is_active: boolean;
}

interface SectionProduct {
  product_id: number;
  product_name: string;
  product_desc: string | null;
  category_id: number;
  selling_price: number | null;
  discount: number | null;
  image_uri: string | null;
  brand: string | null;
  quantity: number;
  rating?: number;
}

export interface HomeSection {
  id: string;
  section_key: string;
  section_title: string | null;
  banners: HomeBanner[];
  products: SectionProduct[];
}

export interface HomeContent {
  heroBanner: HomeSection | null;
  trendingNow: HomeSection | null;
  topArrivals: HomeSection | null;
}

export const mapSectionProduct = (sp: SectionProduct): Product => ({
  id: sp.product_id,
  product_name: sp.product_name,
  product_desc: sp.product_desc || '',
  selling_price: sp.selling_price || 0,
  discount: sp.discount ?? undefined,
  quantity: sp.quantity,
  category_id: sp.category_id,
  brand: sp.brand ?? undefined,
  image_uri: sp.image_uri ? [sp.image_uri] : null,
  rating: sp.rating,
});

export const fetchHomeContent = async (): Promise<HomeContent> => {
  const empty: HomeContent = { heroBanner: null, trendingNow: null, topArrivals: null };
  try {
    const res = await fetch(`${API_BASE}/website_content/home`);
    if (!res.ok) return empty;
    const data = await res.json();
    const sections: HomeSection[] = data.sections || [];
    const result: HomeContent = { ...empty };
    for (const s of sections) {
      if (s.section_key === 'hero_banner') result.heroBanner = s;
      else if (s.section_key === 'trending_now') result.trendingNow = s;
      else if (s.section_key === 'top_arrivals') result.topArrivals = s;
    }
    return result;
  } catch {
    return empty;
  }
};
